import 'minireset.css';

import 'fslightbox';
import 'lazyload';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import riveWASMResource from '@rive-app/canvas-lite/rive.wasm';
import { RuntimeLoader } from '@rive-app/canvas-lite';
RuntimeLoader.setWasmUrl(riveWASMResource);

import './__globals/application/';
import './__globals/config/';
import './__globals/images/';
import './__globals/museo-sans/';
import './__globals/museo-slab/';
import './__globals/roboto/';
import './__globals/roboto-slab/';

import './atoms/button/';
import './atoms/container/';
import './atoms/frame/';
import './atoms/header/';
import './atoms/header-image/';
import './atoms/image/';
import './atoms/list/';
import './atoms/play/';
import './atoms/richtext/';

import './molecules/action-list/';
import './molecules/buttongroup/';
import './molecules/fs-lightbox/';
import './molecules/image-with-text/';
import './molecules/logos/';
import './molecules/pills-menu/';
import './molecules/tile-grid-item/';
import './molecules/videoembeditem/';

import './organisms/accordion/';
import './organisms/back-to-top/';
import './organisms/callout-bubble/';
import './organisms/contactcardlist/';
import './organisms/contact-person/';
import './organisms/contact-map/';
import './organisms/download-list/';
import './organisms/download-teaser/';
import './organisms/feature/';
import './organisms/feature-slider/';
import './organisms/breadcrumbs/';
import './organisms/blockquote/';
import './organisms/hero/';
import './organisms/form/';
import './organisms/iconfactgrid/';
import './organisms/icongrid/';
import './organisms/iconlist1/';
import './organisms/iconlist2/';
import './organisms/iconlist3/';
import './organisms/iconlist4/';
import './organisms/image-full-width/';
import './organisms/infolist/';
import './organisms/infolist2/';
import './organisms/infolist3/';
import './organisms/imageteaser/';
import './organisms/image-slider/';
import './organisms/quotelist/';
import './organisms/inlinevideo/';
import './organisms/joboffer-detail/';
import './organisms/joboffer-teaser/';
import './organisms/location/';
import './organisms/location-slider/';
import './organisms/logogrid/';
import './organisms/numbered-list/';
import './organisms/page-error/';
import './organisms/popup/';
import './organisms/portrait-gallery/';
import './organisms/profile/';
import './organisms/site/';
import './organisms/site-header/';
import './organisms/site-footer/';
import './organisms/secure-viewer/';
import './organisms/safety-briefing/';
import './organisms/quick-apply/';
import './organisms/slidergallery/';
import './organisms/text/';
import './organisms/text-2col/';
import './organisms/text-2col-6633/';
import './organisms/text-on-image/';
import './organisms/text-with-image/';
import './organisms/sliding-panes-menu';
import './organisms/teaser-tiles/';
import './organisms/tile-grid/';
import './organisms/tile-grid-sublevel/';
import './organisms/tilelist/';
import './organisms/map/';
import './organisms/mosaic/';
import './organisms/mosaicgallery/';
import './organisms/header/';
import './organisms/header-search/';
import './organisms/search-results/';
import './organisms/post-list/';
import './organisms/text-2col-3366/';
import './organisms/team/';
import './organisms/history/';
import './organisms/hotline/';
import './organisms/seasonal-hero/';
import './organisms/videoembed/';
import './organisms/videoteaser/';
import './organisms/language-menu/';
import './organisms/text-and-image-slider/';
import './organisms/text-teaser-tiles/';
import './organisms/text-with-photo/';

import './pages/post/';

import './atoms/canvas/'; // IMPORTANT: Should be included last.

window.app.run(() => {
    window.lazyload();

    if (window.location.hash) {
        setTimeout(() => {
            window.app.scrollToHash(window.location.hash);
        }, '500');
    }

    Array.from(document.querySelectorAll('a[href^="#"]')).filter((node) => {
        return !node.hasAttribute('data-fslightbox')
            && !node.hasAttribute('data-mailto-token')
            && !node.hasAttribute('data-popup');
    }).forEach((node) => {
        node.addEventListener('click', (event) => {
            event.stopImmediatePropagation();
            event.preventDefault();

            const url = new URL(event.target.closest('a').href);
            window.app.scrollToHash(url.hash);
        });
    });
});
